import { render, staticRenderFns } from "./DirectCustomerReview.vue?vue&type=template&id=224f18d2&scoped=true"
import script from "./DirectCustomerReview.vue?vue&type=script&lang=js"
export * from "./DirectCustomerReview.vue?vue&type=script&lang=js"
import style0 from "./DirectCustomerReview.vue?vue&type=style&index=0&id=224f18d2&prod&lang=less&scoped=true"
import style1 from "./DirectCustomerReview.vue?vue&type=style&index=1&id=224f18d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f18d2",
  null
  
)

export default component.exports